import { $, T } from "../../common/drupal/drupal";

class Classes {

    constructor() {
        this.sessions = drupalSettings.sessions;
    }
    /**
     * init
     */
    init() {
        moment.locale(drupalSettings.langCode);
        let allSessions = [];

        for (const session of this.sessions) {
            let eventDate = new Date(session.start_time * 1000);
            allSessions.push({
                'Date': new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate()),
                ...session
            });
        }
        let $classWrapper = $('.class-info-wrapper');
        $.datepicker.setDefaults($.datepicker.regional["fr"]);
        if (this.sessions.length > 1) {
            $('[data-toggle="datepicker"]').datepicker({
                dateFormat: "dd/mm/yy",
                dayNamesMin: $.datepicker.regional["fr"].dayNamesShort,
                beforeShowDay: function (date) {
                    var day = date.getDay();
                    var result = [true, '', null];
                    var currentSession;
                    var matching = $.grep(allSessions, function (aSession) {
                        if (aSession.Date.valueOf() === date.valueOf()) {
                            currentSession = aSession;
                            return true;
                        }
                    });
                    if (matching.length) {
                        result = [true, 'highlight', `${matching.length} réservation(s)` ];
                    } else {
                        result = [day > 0 && day < 6, ''];
                    }
                    return result;
                }.bind(this),
                onSelect: function (date, inst) {
                    let selectedSession     = [];
                    let dateToCompare       = moment(date, "DD MM YYYY").format();
                    let TranSelectedSession = {};
                    var matching            = $.grep(allSessions, function (aSession) {
                        if (aSession.Date.valueOf() === new Date(dateToCompare).valueOf()) {
                            selectedSession.push( aSession );
                            return true;
                        }
                    });
                    for ( var i = 0; i < selectedSession.length; i++ ) {
                        if ( !TranSelectedSession.hasOwnProperty( selectedSession[i].site ) ) {
                            TranSelectedSession[ selectedSession[i].site ] = {
                                'name' : selectedSession[i].site,
                                'adress': selectedSession[i].adress,
                                'cp': selectedSession[i].cp,
                                'town': selectedSession[i].town,
                                'date': selectedSession[i].start_time,
                                'room' : {}
                            };
                        }
                        if ( !TranSelectedSession[ selectedSession[i].site ].room.hasOwnProperty( selectedSession[i].room ) ) {
                            TranSelectedSession[ selectedSession[i].site ].room[ selectedSession[i].room ] = {
                                'name': selectedSession[i].room,
                                'hours': []
                            }
                        }
                        TranSelectedSession[ selectedSession[i].site ].room[ selectedSession[i].room ].hours.push(
                            {
                                'start_time': selectedSession[i].start_time,
                                'end_time': selectedSession[i].end_time
                            }
                        );
                    }
                    if (matching.length) {
                        $classWrapper.html("");
                        $classWrapper.html(this.generateClassInfos(TranSelectedSession));
                    }
                }.bind(this),
            });
        }
    }

    /**
     * [getSessionHours description]
     * @param  {[type]} session [description]
     * @return {[type]}         [description]
     */
    getSessionHours(session) {
        let start_hour = `${moment(session.start_time * 1000).format("HH")}h${moment(session.start_time * 1000).format("mm")}`;
        let end_hour = `${moment(session.end_time * 1000).format("HH")}h${moment(session.end_time * 1000).format("mm")}`;
        return {
            start: `${start_hour}`,
            end: `${end_hour}`
        };
    }

    /**
     * [getSessionHours description]
     * @param  {[type]} session [description]
     * @return {[type]}         [description]
     */
    getSessionDate(date) {
        const sessionDate = moment(date * 1000).format("dddd DD MMMM YYYY");
        return `Le ${sessionDate}`;
    }

    /**
     * [getSessionHours description]
     * @param  {[type]} session [description]
     * @return {[type]}         [description]
     */
    generateClassInfos(session) {
        let output = $('<article>').addClass( 'courseCalendarInfo' ).html('');
        let header = $('<header>');
        for( let site in session ){
            header.html( this.getSessionDate( session[site].date ) );
            let content  = $('<div>').addClass( 'courseCalendarInfo-content' );
            let Isite    = $('<div>').addClass( 'courseCalendarInfo-site' ).html( site );
            let address  = $('<div>').addClass( 'courseCalendarInfo-address' ).html( session[site].adress );
            let cpTown   = $('<div>').addClass( 'courseCalendarInfo-cpTown' ).html( `${session[site].cp} ${session[site].town}` );
            content
                .append( Isite )
                .append( address )
                .append( cpTown );
            for( let room in session[site].room ){
                var infoRoom    = $('<div>').addClass( 'courseCalendarInfo-room' ).append( `<span>- Salle :</span> ${room}` );
                let infoHours   = $('<ul>').addClass( 'courseCalendarInfo-hours' );
                for (var i = 0; i < session[site].room[room].hours.length; i++) {
                    let li = $('<li>').html( `de ${this.getSessionHours( session[site].room[room].hours[i] ).start} à ${this.getSessionHours(session[site].room[room].hours[i] ).end}` );
                    infoHours.append( li );
                }
                infoRoom.append( infoHours );
                content.append( infoRoom );
            }
            output.append( content );
        }
        return output.prepend( header );
    }

    /**
     * Attach.
     * @param context
     */
    attach(context) {
        if (T.contextIsRoot(context) && drupalSettings.sessions) {
            $('.calendar').show();
            this.init();
        }
    }
}

export let classes = new Classes();
